import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import { IConversionConfig, ISegmentConfigData } from '../../utils/type';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const location = useLocation();
	const { requestCreateConfig } = useService();

	const CloneConfig = (conversionConfig: IConversionConfig) => {
		setShowLoader(true);
		requestCreateConfig(app.appName, { ...conversionConfig }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while cloning the CTD config'}`, { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Config Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: ISegmentConfigData) => {
		CloneConfig(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};
	const segmentLabelList: { id: string; label: string }[] = history?.location?.state?.segmentList;
	const expLabelList: { id: string; label: string }[] = history?.location?.state?.expList;
	const bucketList: { [key: string]: string } = history?.location?.state?.bucketList;
	return {
		data: {
			...hydrateFormData(_get(location, ['state', 'rowData'], EMPTY_OBJECT)),
			...{ segmentLabelList, expLabelList, bucketList }
		},
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
